import React, { useEffect, useState } from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import CascadeHelp from './CascadeHelp';
import CascadeCurrency from './CascadeCurrency';
import { API_CASINO } from '../../../../../api/casino';
import useNumberParams from '../../../../../hooks/useNumberParams';
import { TEST_MODE } from '../../../../../enums/enums';
import { Stack } from '@mui/material';

export default function PaymentCascade() {
  const casinoId = useNumberParams('casinoId');
  const [cascadeInfo, setCascadeInfo] = useState({});
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (TEST_MODE) {
      setLoader(false);
      return;
    }

    API_CASINO.cascade
      .get({ casinoId })
      .then((e) => {
        const data = e.data.data;
        data.gateInfo.reactId = Math.random();
        setCascadeInfo(data);
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  }, [casinoId]);

  return (
    <CasinoContainer title={'Payment providers cascade'}>
      <Stack direction={'column'} height={'100%'}>
        <CascadeHelp cascadeHelp={cascadeInfo.gateInfo} />
        <CascadeCurrency cascade={cascadeInfo} casinoId={casinoId} loader={loader} />
      </Stack>
    </CasinoContainer>
  );
}
